import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const placeholderSpec = {
  inline: false,
  attrs: {
    type: {
      default: 'placeholder'
    }
  },
  group: 'block',
  atom: true,
  allowGapCursor: false,
  parseDOM: [],
  toDOM() {
    return ['div', {
      class: `${BLOCK_CLASSES.placeholder}`
    }];
  }
};